import { Component, OnInit, ViewChild, Input, effect, inject, Injector, ChangeDetectorRef } from "@angular/core"; import { Location } from "@angular/common";
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { MenuItem, SortMeta } from 'primeng/api';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ItemService } from '../../services/item-service';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../base/base-component';
import { CommandeService } from '../../services/commande-service';
import { Emplacement } from '../../entites/emplacement';
import { EmplacementService } from '../../services/emplacement-service';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { SelectionItemComponent, ETypeSelectionItem, ResultatSelectionItem } from 'src/app/controles/selection-item.component';
import { ItemCommandeEntite } from 'src/app/entites/item-commande';
import { SignalWithWatcher } from 'src/app/services/base.service';
import { ReponseObtenirCommande } from 'src/app/services/reponses/reponse-obtenir-commande';
import { ReponseBase } from 'src/app/services/reponse-base';
import { ContextMenu } from 'primeng/contextmenu/public_api';
import { Statut } from 'src/app/entites/statut';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { ProfilService } from 'src/app/services/profil-service';
import { InfoChangementStatut } from 'src/app/entites/info-changement-statut';
import { RequeteModifierItemCommande } from 'src/app/services/requetes/requete-modifier-item-commande';
import { AppMainComponent } from 'src/app/app.main.component';
import { RapportService } from 'src/app/services/rapport-service';
import { ModifierPreCommandeComponent } from "../../controles/modifier-pre-commande.component";
import { ActiviteService } from 'src/app/services/activite-service';
import { ActiviteEntite } from 'src/app/entites/activite';
import { ETypeLien } from "src/app/entites/enums/type-lien-document";
import { TimelineConfig } from 'src/app/controles/timeline-activite.component';
import { RequisitionService } from '../../services/requisition-service';
import { RequisitionMin } from '../../entites/requisition-min';
import { ETypeFavori } from "src/app/entites/enums/type-favori";

@Component({
    selector: 'app-detail-commande',
    templateUrl: './detail-commande.component.html',
    styleUrls: ['./detail-commande.component.scss'],
    providers: [MessageService, ConfirmationService, DialogService],
    host: {
        '(document:keydown)': 'handleKeyboardEvents($event)'
    }
})
export class DetailCommandeComponent extends BaseComponent implements OnInit {

    @Input() emplacementId: number;
    emplacement: Emplacement;

    @Input() modeStandard: boolean = true;

    itemsCommande: ItemCommandeEntite[];
    selectionItemCommande: ItemCommandeEntite;
    selectionMultipleItemCommande: ItemCommandeEntite[] = [];
    menuContextuelEntrees: MenuItem[];

    codeActiviteId?: number = null;
    codeCategorieId?: number = null;

    statuts: Statut[] = this.sdb.StatutsCommande();

    ref: DynamicDialogRef;

    menu: MenuItem[];

    injector = inject(Injector);
    private cdr = inject(ChangeDetectorRef);

    sortMeta: SortMeta[] = [
        { field: 'indBrouillon', order: -1 },
        { field: 'dateDemande', order: -1 }
    ];

    sortMetaTransports: SortMeta[] = [
        { field: 'date', order: -1 },
        { field: 'numero', order: -1 }
    ];

    private precommandeSignalWatcher: SignalWithWatcher<ReponseBase<ReponseObtenirCommande>>;

    // Timeline properties
    activites: ActiviteEntite[] = [];
    activitesChargees: boolean = false;
    timelineVisible: boolean = false;
    timelineConfig: TimelineConfig = {
        title: 'Historique des modifications',
        description: 'Chronologie de toutes les actions effectuées sur cette commande',
        showReloadButton: true,
        emptyMessage: 'Aucune activité trouvée pour cette commande'
    };

    // Transport properties
    transports: RequisitionMin[] = [];
    transportsCharges: boolean = false;
    expandedRowsTransports: { [key: string]: boolean } = {};

    @ViewChild('menuContextuelItemCommande') menuContextuelItemCommande: ContextMenu;
    @ViewChild('dt') dt: Table;
    @ViewChild('dtTransports') dtTransports: Table;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        private breadcrumbService: BreadcrumbService,
        private CommandeService: CommandeService,
        private EmplacementService: EmplacementService,
        private ItemsService: ItemService,
        private messageService: MessageService,
        private rapportService: RapportService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router,
        route: ActivatedRoute,
        appMain: AppMainComponent, location: Location,
        private activiteService: ActiviteService,
        private requisitionService: RequisitionService) {

        super(sdb, profilService, route, routerService, appMain);

        this.breadcrumbService.setItems([
            { label: 'commande', routerLink: '/commande' },
            { label: 'Détails' }
        ]);
        this.route.params.subscribe(params => { console.log(params.id); this.emplacementId = this.emplacementId || params.id as number; });
    }

    ngOnInit() {

        this.verifierAccesPage('precommande_detail');



        // Setup effect for real-time updates BEFORE subscribing
        effect(() => {
            if (this.precommandeSignalWatcher && this.precommandeSignalWatcher.updates()) {
                const update = this.precommandeSignalWatcher.updates();
                if (update) {
                    const updatedData = this.precommandeSignalWatcher.value().valeur;
                    this.itemsCommande = updatedData.itemsCommande;
                    this.itemsCommande.forEach(item => {
                        item.indBrouillon = item.statut.statutId == EStatuts.EnCours;
                    });
                    this.emplacement = updatedData.emplacement;
                    this.cdr.detectChanges();
                }
            }
        }, { injector: this.injector });

        this.CommandeService.ObtenirPrecommande(this.emplacementId,
            (data: ReponseBase<ReponseObtenirCommande>) => {
                if (data.estUnSucces && data.valeur?.itemsCommande) {
                    data.valeur.itemsCommande.forEach(item => {
                        item.indBrouillon = item.statut.statutId == EStatuts.EnCours;
                    });
                    return data;
                }
                return null;
            }
        ).subscribe({
            next: (signalWatcher: SignalWithWatcher<ReponseBase<ReponseObtenirCommande>>) => {
                this.precommandeSignalWatcher = signalWatcher;

                const commandeData = signalWatcher.value().valeur;
                this.itemsCommande = commandeData.itemsCommande;
                this.emplacement = commandeData.emplacement;

                this.CompleterChargement(`Commande - ${this.emplacement.nom} (${this.emplacement.code})`);

                this.chargerActivites();
                this.chargerTransports();
            }
        });

        this.initialiserMenu();
    }

    initialiserMenu() {
        this.menu = [
            {
                label: 'Retour', icon: 'pi pi-fw pi-angle-double-left', command: () => window.history.back(), visible: this.modeStandard
            },
            {
                label: 'Imprimer', icon: 'pi pi-fw pi-print', command: () => this.imprimer()
            },
            {
                label: 'Actions multiples',
                icon: 'pi pi-fw pi-bars',
                visible: this.estAutorise('precommande_modifier') || this.estAutorise('precommande_envoyer_approbation'),
                disabled: this.selectionMultipleItemCommande.length == 0,
                items: [
                    {
                        label: 'Envoyer en approbation',
                        icon: 'pi pi-fw pi-forward',
                        visible: this.estAutorise('precommande_envoyer_approbation'),
                        command: () => this.changerStatutLot(6)
                    },
                    {
                        separator: true, visible: this.estAutorise('precommande_modifier')
                    },
                    {
                        label: 'Supprimer',
                        icon: 'pi pi-fw pi-times',
                        visible: this.estAutorise('precommande_modifier'),
                        command: () => this.supprimerItemsCommande(this.selectionMultipleItemCommande)
                    },
                ]
            },
            {
                label: 'Historique',
                icon: 'pi pi-fw pi-history',
                command: () => this.basculerTimeline()
            },
        ];
    }

    handleKeyboardEvents(event: KeyboardEvent) {
        // if (event.key == '+' && !this.estFenetreAjoutItemActive) {
        //     this.surAjoutItem();
        // }
    }

    imprimer() {
        this.messageService.add({ severity: 'info', summary: 'Demande de rapport', detail: `Votre demande de rapport a été envoyée.` });

        this.rapportService.ProduireRapportPreCommande(this.emplacementId).then(x => {
            if (x) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Votre rapport a été généré.` });
            } else {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue pendant la génération de votre rapport.` });
            }
        });
    }

    estFenetreAjoutItemActive: boolean = false;
    surAjoutItem() {
        this.estFenetreAjoutItemActive = true;
        const ref = this.dialogService.open(SelectionItemComponent, {
            data: {
                type: ETypeSelectionItem.PreCommande,
                employeId: this.profilService.ProfilCourant().employeId,
                selectionCodeProjet: this.emplacement.codeProjet?.codeProjetId,
                selectionCodeActivite: this.codeActiviteId,
                selectionCodeCategorie: this.codeCategorieId
            },
            header: 'Sélection d\'un item',
            width: '95%',
        }).onClose.subscribe((res: ResultatSelectionItem) => {
            if (res) {

                this.estFenetreAjoutItemActive = false;

                var itemCommande: ItemCommandeEntite = {
                    itemCommandeId: 0,
                    emplacement: { emplacementId: this.emplacement.emplacementId },
                    item: res.item,
                    statut: this.sdb.Statut(EStatuts.EnCours),
                    employe: this.profilService.ProfilCourant(),
                    dateDemande: new Date(),
                    quantiteDemande: res.quantiteDemande,
                    quantite: res.quantiteDemande,
                    expediteur: res.expediteur,
                    demandeur: res.demandeur,
                    dateRequis: res.dateRequis,
                    codeProjet: res.codeProjet,
                    codeActivite: res.codeActivite,
                    codeCategorie: res.codeCategorie,
                    codeExtra: res.codeExtra,
                    codeEquipement: res.codeEquipement,
                    note: res.note,
                    indPrecommande: true
                }

                this.DemarrerChargement();
                this.CommandeService.CreerItemCommande({
                    itemCommande: itemCommande
                }).then(res => {
                    if (res.estUnSucces) {


                        itemCommande.itemCommandeId = res.valeur.itemCommande.itemCommandeId;
                        itemCommande.indBrouillon = true;
                        this.itemsCommande.push(itemCommande);
                        this.CompleterChargement();
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: `L'item '${itemCommande.item.description} (${itemCommande.item.numero})' a été ajouté.` });

                    } else {
                        this.CompleterChargement();
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

                this.codeActiviteId = res.codeActivite?.codeActiviteId;
                this.codeCategorieId = res.codeCategorie.codeCategorieId;

            }
        });

    }

    rafraichir() {
        this.CommandeService.ObtenirPrecommande(this.emplacementId).subscribe({
            next: (signalWatcher: SignalWithWatcher<ReponseBase<ReponseObtenirCommande>>) => {
                this.precommandeSignalWatcher = signalWatcher;
            }
        });
    }

    surChangementSelection() {
        this.selectionMultipleItemCommande = this.selectionMultipleItemCommande.filter(x => x.statut.statutId == EStatuts.EnCours);
        this.initialiserMenu();
    }

    supprimerItemcommnde(vent, item: ItemCommandeEntite) {
        this.confirmationService.confirm({
            message: 'Voulez-vous vraiment supprimer l\'item "' + item.item.description + '" ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.CommandeService.SupprimerItemCommande(item.itemCommandeId).then(res => {
                    if (res.estUnSucces) {
                        this.itemsCommande = this.itemsCommande.filter(val => val.itemCommandeId != item.itemCommandeId);
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Item supprimé.' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });
    }

    supprimerItemsCommande(items: ItemCommandeEntite[]) {
        this.confirmationService.confirm({
            message: 'Voulez-vous vraiment supprimer les items sélectionnnés ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                var ids = items.map(x => x.itemCommandeId);
                this.CommandeService.SupprimerItemsCommande(ids).then(res => {
                    if (res.estUnSucces) {

                        this.itemsCommande = this.itemsCommande.filter((i: ItemCommandeEntite) => !ids.includes(i.itemCommandeId))

                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Items supprimés.' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });
    }

    surMenuContextuelItem(event, itemCommande: ItemCommandeEntite) {
        this.selectionItemCommande = itemCommande;

        this.menuContextuelEntrees = [
            {
                label: 'Voir l\'item',
                icon: 'pi pi-fw pi-search',
                visible: this.estAutorise('item_detail'),
                command: () => this.routerService.navigateByUrl(`item/${itemCommande.item.itemId}`)
            },
            {
                label: 'Modifier',
                icon: 'pi pi-fw pi-pencil',
                visible: this.estAutorise('precommande_modifier'),
                command: () => this.modifierPC(itemCommande)
            },
            { separator: true },
            {
                label: 'Envoyer en approbation',
                icon: 'pi pi-fw pi-forward',
                visible: this.estAutorise('precommande_envoyer_approbation'),
                command: x => this.changerStatut(itemCommande.itemCommandeId, itemCommande.quantite, 6, itemCommande.item.description)
            },
        ];


        this.menuContextuelItemCommande.toggle(event);
    }

    modifierPC(itemCommande: ItemCommandeEntite) {
        const ref = this.dialogService.open(ModifierPreCommandeComponent, {
            data: {
                itemCommandeId: itemCommande.itemCommandeId
            },
            header: 'Détails de la commande',
            width: '95%'
        }).onClose.subscribe((res: ItemCommandeEntite) => {
            if (res) {
                const myItem = res;
                this.CommandeService.ModifierqteItemCommande({
                    employe: this.profilService.ProfilCourant(),
                    emplacement: this.emplacement,
                    itemsCommande: [{
                        itemCommandeId: myItem.itemCommandeId,
                        quantite: myItem.quantiteDemande
                    }]
                }).then(res => {
                    if (!res.estUnSucces) {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                        return Promise.reject();
                    } else {

                        res.valeur.itemCommandeModifies.forEach(x => {
                            const itemCommandeAModifier = this.itemsCommande.find(ic => ic.itemCommandeId == x.itemCommandeId);
                            itemCommandeAModifier.quantiteDemande = x.quantiteDemande;
                            itemCommandeAModifier.quantite = x.quantite;
                        });

                        return this.CommandeService.ModifierItemPreCommande(myItem.itemCommandeId, { itemCommande: myItem });
                    }
                }).then(res => {
                    if (res.estUnSucces) {
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: `L'item '${myItem.item.description} (${myItem.item.numero})' a été modifié.` });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                    this.ngOnInit();
                })
                    .catch(() => {
                        this.routerService.navigateByUrl('error');
                    });
            }

        });
    }

    changerStatut(itemCommandeId: number, quantite: number, statutId: number, description: string) {

        this.confirmationService.confirm({
            message: 'Voulez-vous vraiment envoyer l\'item "' + description + ' en approbation" ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.confirmerChangerStatut([{
                    itemCommandeId: itemCommandeId,
                    quantite: quantite,
                    statutId: statutId,
                    description: description,
                    indPrecommande: true
                }]);
            }
        });
    }

    changerStatutTous(statutId: number) {
        this.selectionMultipleItemCommande = this.itemsCommande.filter(x => x.indBrouillon);
        this.changerStatutLot(statutId);
    }

    changerStatutLot(statutId: number) {
        if (this.selectionMultipleItemCommande.length > 0) {
            var infos: InfoChangementStatut[] = [];

            this.selectionMultipleItemCommande.forEach(ic => {
                infos.push({
                    itemCommandeId: ic.itemCommandeId,
                    quantite: ic.quantite,
                    statutId: statutId,
                    description: ic.item.description,
                    indPrecommande: true
                });
            });

            this.confirmationService.confirm({
                message: 'Voulez-vous vraiment envoyer les items sélectionnés en approbation" ?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.confirmerChangerStatut(infos);
                }
            });

        }
    }

    confirmerChangerStatut(infos: InfoChangementStatut[]) {

        var requete: RequeteModifierItemCommande = {
            employe: this.profilService.ProfilCourant(),
            emplacement: this.emplacement,
            itemsCommande: []
        };

        infos.forEach(x => {
            requete.itemsCommande.push({
                itemCommandeId: x.itemCommandeId,
                quantite: x.quantite,
                statutId: x.statutId,
                indPrecommande: x.indPrecommande
            });
        });

        this.CommandeService.ModifierItemCommande(requete).then(res => {
            if (res.estUnSucces) {

                infos.forEach(i => {
                    var ic = this.itemsCommande.find(x => x.itemCommandeId == i.itemCommandeId);
                    ic.statut = this.sdb.Statut(EStatuts.EnApprobation);
                    ic.indBrouillon = false;
                });

                this.selectionMultipleItemCommande = [];

                this.CommandeService.EnvoyerCourrielApprobation(requete).then();

                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Envoi en approbation complété.` });

                this.initialiserMenu();
            } else {
                res.messages.forEach(x => {
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                });
            }
        });
    }

    /**
     * Loads activities related to this commande using server-side filtering
     */
    chargerActivites() {
        if (!this.emplacement || !this.itemsCommande) {
            return;
        }

        // Use EmplacementId as the primary filter - this will be more efficient
        // and the backend will handle the JSON metadata filtering
        const filtres = {
            EmplacementId: this.emplacement.emplacementId
        };

        this.activiteService.FiltrerParMetadata(ETypeLien.ItemCommande, filtres, 100).subscribe({
            next: (response) => {
                if (response.estUnSucces && response.valeur) {
                    // The backend now handles the metadata filtering
                    // We can still do some client-side refinement if needed
                    this.activites = response.valeur
                        .filter(activite => {
                            // Optional: Still filter by commande-related activities if needed
                            // Remove this filter if you want all activities for the emplacement
                            return activite.typeLien.typeLienId === ETypeLien.ItemCommande;
                        })
                        .sort((a, b) => {
                            // Sort by activity date descending (most recent first)
                            // Use the new Date field, fallback to dateCreation if Date is not available
                            const dateA = new Date(a.date || a.dateCreation || 0).getTime();
                            const dateB = new Date(b.date || b.dateCreation || 0).getTime();
                            return dateB - dateA;
                        });

                    this.activitesChargees = true;
                } else {
                    console.warn('No activities found or error in response');
                    this.activites = [];
                    this.activitesChargees = true;
                }
            },
            error: (error) => {
                console.error('Error loading activities:', error);
                this.activites = [];
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: 'Erreur lors du chargement de l\'historique'
                });
                this.activitesChargees = true;
            }
        });
    }

    /**
     * Loads transports for the current emplacement
     */
    chargerTransports() {
        if (!this.emplacement) {
            return;
        }

        this.requisitionService.ObtenirRequisitions(this.emplacement.emplacementId).then(response => {
            if (response.estUnSucces && response.valeur) {
                // Filter transports to only show those related to the current emplacement
                this.transports = response.valeur.filter(transport =>
                    transport.a?.emplacementId === this.emplacement.emplacementId &&
                    transport.statut.statutId != EStatuts.Complete
                );
                this.transportsCharges = true;
            } else {
                console.warn('No transports found or error in response');
                this.transports = [];
                this.transportsCharges = true;
            }
        }).catch(error => {
            console.error('Error loading transports:', error);
            this.transports = [];
            this.transportsCharges = true;
            this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Erreur lors du chargement des transports'
            });
        });
    }

    /**
     * Toggles the timeline visibility
     */
    basculerTimeline() {
        if (!this.timelineVisible) {
            setTimeout(() => {
                var timeline = document.getElementById('timeline');
                timeline.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
        this.timelineVisible = !this.timelineVisible;
        if (this.timelineVisible && !this.activitesChargees) {
            this.chargerActivites();
        }
    }

    /**
     * Handles navigation from timeline component
     */
    onTimelineNavigate(routerLink: string) {
        // Navigation is handled by the timeline component itself
        // This method can be used for additional logic if needed
        console.log('Navigating to:', routerLink);
    }



    /**
     * Parses metadata JSON and returns user-friendly key-value pairs
     */
    parseMetadata(metadata: string): { label: string, value: string }[] {
        if (!metadata) return [];

        try {
            const data = JSON.parse(metadata);
            const result: { label: string, value: string }[] = [];

            // Map common fields to user-friendly labels
            const fieldMappings: { [key: string]: string } = {
                'itemCommandeId': 'ID Item Commande',
                'itemCommandeIds': 'IDs Items Commande',
                'itemId': 'ID Item',
                'emplacementId': 'ID Emplacement',
                'quantite': 'Quantité',
                'count': 'Nombre d\'items',
                'action': 'Type d\'action',
                'modifications': 'Modifications'
            };

            Object.keys(data).forEach(key => {
                const value = data[key];
                if (value !== null && value !== undefined) {
                    const label = fieldMappings[key] || this.capitalizeFirst(key);

                    // Format different types of values
                    let displayValue: string;
                    if (Array.isArray(value)) {
                        displayValue = value.join(', ');
                    } else if (typeof value === 'object') {
                        displayValue = JSON.stringify(value, null, 2);
                    } else {
                        displayValue = value.toString();
                    }

                    result.push({ label, value: displayValue });
                }
            });

            return result;
        } catch (e) {
            console.warn('Failed to parse metadata:', e);
            return [{ label: 'Données brutes', value: metadata }];
        }
    }

    /**
     * Capitalizes the first letter of a string
     */
    private capitalizeFirst(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    isDateRequisExpired(dateRequis: Date): boolean {
        return dateRequis && dateRequis < new Date();
    }

    get eTypeFavori(): ETypeFavori {
        return ETypeFavori.Commande;
    }

    obtenirFiltresTransports(): any {
        return {
            rows: 100,
            multiSortMeta: JSON.stringify([
                { field: 'date', order: -1 },
                { field: 'numero', order: -1 }
            ]),
            filters: JSON.stringify({
                'a.nom': [{
                    value: [this.emplacement.nom],
                    matchMode: 'in',
                    operator: 'and'
                }]
            })
        };
    }
}
